// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"8fb064d9","281":"96ec6803","639":"5c6144d9","876":"49a0ee4d"}[chunkId] + ".css";
};